// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.crt-title {
  font-size: 2rem;
  margin-bottom: 1rem;
}

.crt-detail-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
}

.crt-main {
  flex: 2 1;
  min-width: 300px;
}

.crt-sidebar {
  flex: 1 1;
  min-width: 250px;
}

.meta {
  font-size: 0.875rem;
  color: #888;
}

.crt-image img {
  max-width: 100%;
  border-radius: 0.5rem;
  margin-bottom: 1rem;
}

.mod-label {
  display: inline-block;
  padding: 4px 8px;
  margin: 0 4px 4px 0;
  border-radius: 4px;
  font-size: 0.85rem;
  color: white;
  text-decoration: none;
}

.mod-notes {
  margin-bottom: 1rem;
  background-color: #2b132b;
  padding: 1rem;
  border-radius: 0.5rem;
}

.mod-link {
  display: inline-block;
  margin-bottom: 1.5rem;
  font-weight: 500;
  color: #0d6efd;
  text-decoration: none;
}

.mod-link:hover {
  text-decoration: underline;
}

.mod-chassis-label {
  background-color: #ff009d;
  color: #ffffff;
  padding: 3px 8px;
  margin: 2px;
  border-radius: 4px;
  display: inline-block;
  font-size: 0.75rem;
  font-weight: 500;
}

.mod-board-label {
  background-color: #e0f7fa;
  color: #007b83;
  padding: 3px 8px;
  margin: 2px;
  border-radius: 4px;
  display: inline-block;
  font-size: 0.75rem;
  font-weight: 500;
}

/* Mod Board Purchase Links */
.mod-board-purchase-link {
  background-color: #e0f7fa;
  color: #007b83;
  border: 1px solid #b2ebf2;
  padding: 0.35rem 0.75rem;
  margin-right: 0.5rem;
  margin-bottom: 0.25rem;
  border-radius: 6px;
  display: inline-block;
  font-size: 0.8rem;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.1s ease-in-out;
  cursor: pointer;
}

.mod-board-purchase-link:hover {
  background-color: #00525d;
  color: #ffffff;
  border-color: #80deea;
  box-shadow: 0 2px 4px rgba(0, 123, 131, 0.2);
  text-decoration: none;
}

.mod-board-purchase-link:active {
  box-shadow: 0 1px 2px rgba(0, 123, 131, 0.2);
}

.info-card {
  background-color: #2b132b;
  border-radius: 0.5rem;
  padding: 1rem;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
  font-size: 0.9rem;
}

.info-item {
  margin-bottom: 0.5rem;
}


.crt-hero-image img {
  width: 100%;
  object-fit: contain;
  border-radius: 8px;
}

.crt-gallery {
  margin-top: 2rem;
}

.gallery-thumb:hover {
  transform: scale(1.02);
}

.masonry-grid {
  display: flex;
  margin-left: -1rem; /* gutter */
  width: auto;
}
.masonry-grid_column {
  padding-left: 1rem; /* gutter */
  background-clip: padding-box;
}
.gallery-thumb {
  margin-bottom: 1rem;
  width: 100%;
  border-radius: 6px;
}

/* Add styles for the CRT summary section */
.crt-summary {
  background-color: rgba(0, 0, 0, 0.03);
  border-radius: 8px;
  line-height: 1.6;
}

.crt-summary h5 {
  margin-bottom: 1rem;
  color: #ccc;
  font-weight: 600;
}

.crt-summary .markdown-body p {
  margin-bottom: 1rem;
}

.crt-summary .markdown-body p:last-child {
  margin-bottom: 0;
}

.crt-summary .markdown-body ul, 
.crt-summary .markdown-body ol {
  padding-left: 1.5rem;
  margin-bottom: 1rem;
}

.crt-summary .markdown-body a {
  color: #0d6efd;
  text-decoration: none;
}

.crt-summary .markdown-body a:hover {
  text-decoration: underline;
}

.crt-summary .markdown-body code {
  background-color: rgba(0, 0, 0, 0.1);
  padding: 0.2rem 0.4rem;
  border-radius: 3px;
  font-family: monospace;
}

/* Community Contributions Section */
.crt-community-content {
  background-color: rgba(0, 0, 0, 0.03);
  border-radius: 8px;
}

.crt-community-content h5 {
  margin-bottom: 0.5rem;
  color: #ccc;
  font-weight: 600;
}

.community-content-description {
  color: #aaa;
  font-size: 0.9rem;
}

.community-thumb {
  margin-bottom: 1rem;
  width: 100%;
  border-radius: 6px;
  transition: transform 0.2s ease-in-out;
}

.community-thumb:hover {
  transform: scale(1.02);
}

.community-placeholder {
  background-color: #2b132b;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 150px;
  color: #aaa;
  text-align: center;
  padding: 1.5rem;
}

.placeholder-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
}

.placeholder-type {
  background-color: rgba(255, 255, 255, 0.1);
  padding: 0.15rem 0.5rem;
  border-radius: 3px;
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.placeholder-link {
  margin-top: 0.5rem;
  color: #0d6efd;
  text-decoration: none;
  font-size: 0.9rem;
  border: 1px solid rgba(255, 255, 255, 0.2);
  padding: 0.2rem 0.7rem;
  border-radius: 3px;
  transition: all 0.2s;
}

.placeholder-link:hover {
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
}

@media (max-width: 768px) {
  .community-content-item {
    margin-bottom: 1rem;
  }
  
  .community-content-image {
    margin-bottom: 0.5rem;
  }
  
  .community-content-placeholder {
    height: 100px;
  }
  
  .community-content-title {
    font-size: 0.9rem;
  }
}

@media (max-width: 480px) {
  .crt-community-content {
    padding: 1rem;
  }
  
  .community-content-meta {
    font-size: 0.7rem;
  }
  
  .community-content-type {
    font-size: 0.65rem;
    padding: 0.1rem 0.3rem;
  }
}

/* Adjust masonry grid specifically for community content */
.crt-community-content .masonry-grid_column > div {
  margin-bottom: 20px;
}

/* Community contributions now use the same masonry grid as gallery images */

.community-contributors {
  font-size: 0.85rem;
  color: #a0a0a0;
  margin-top: -5px;
}

.contributor {
  font-weight: 500;
}

.community-date {
  color: #888;
  font-style: italic;
}

.community-product-section {
  margin-bottom: 2rem;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.community-product-section:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.community-product-header {
  margin-bottom: 1rem;
}

.community-product-title {
  margin-bottom: 0.3rem;
  font-size: 1.1rem;
}

.community-product-title a {
  color: #0d6efd;
  text-decoration: none;
}

.community-product-title a:hover {
  text-decoration: underline;
}

.community-product-meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  font-size: 0.85rem;
  color: #aaa;
  margin-bottom: 0.5rem;
}

.community-store-name {
  font-weight: 500;
}

.community-product-type {
  background-color: #2b132b;
  padding: 0.15rem 0.4rem;
  border-radius: 3px;
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.community-product-price {
  font-weight: bold;
  color: #d32f2f;
  margin-left: auto;
}

.community-product-date {
  color: #888;
  font-style: italic;
  font-size: 0.8rem;
}

.community-product-intro {
  font-size: 0.9rem;
  line-height: 1.5;
  margin-bottom: 1rem;
  color: #d9d9d9;
  max-width: 100%;
  overflow-wrap: break-word;
}

/* Modal Navigation Buttons */
.modal-nav-btn {
  background: none !important;
  border: none !important;
  color: white;
  text-shadow: 0 0 3px rgba(0,0,0,0.8);
  transition: all 0.2s ease;
  cursor: pointer;
  z-index: 1050;
}

.modal-nav-btn:hover {
  transform: scale(1.1);
  color: #ea3377 !important;
}

.modal-nav-btn:focus {
  outline: none;
  box-shadow: none;
}

.modal-nav-btn:active {
  transform: scale(1.05);
}

/* Modal Image Styling */
.modal-image-container {
  padding: 60px;
  height: 95vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 6px;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/pages/CRTDetail.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,wBAAwB;EACxB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,4CAA4C;EAC5C,qBAAqB;AACvB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;EACb,yCAAyC;EACzC,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;;AAGA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,kBAAkB,EAAE,WAAW;EAC/B,WAAW;AACb;AACA;EACE,kBAAkB,EAAE,WAAW;EAC/B,4BAA4B;AAC9B;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA,2CAA2C;AAC3C;EACE,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,oCAAoC;AACpC;EACE,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,0CAA0C;EAC1C,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,0CAA0C;EAC1C,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;EAC1C,YAAY;AACd;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;AACF;;AAEA,2DAA2D;AAC3D;EACE,mBAAmB;AACrB;;AAEA,4EAA4E;;AAE5E;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,iDAAiD;AACnD;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA,6BAA6B;AAC7B;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,YAAY;EACZ,oCAAoC;EACpC,yBAAyB;EACzB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":[".crt-title {\n  font-size: 2rem;\n  margin-bottom: 1rem;\n}\n\n.crt-detail-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 2rem;\n}\n\n.crt-main {\n  flex: 2;\n  min-width: 300px;\n}\n\n.crt-sidebar {\n  flex: 1;\n  min-width: 250px;\n}\n\n.meta {\n  font-size: 0.875rem;\n  color: #888;\n}\n\n.crt-image img {\n  max-width: 100%;\n  border-radius: 0.5rem;\n  margin-bottom: 1rem;\n}\n\n.mod-label {\n  display: inline-block;\n  padding: 4px 8px;\n  margin: 0 4px 4px 0;\n  border-radius: 4px;\n  font-size: 0.85rem;\n  color: white;\n  text-decoration: none;\n}\n\n.mod-notes {\n  margin-bottom: 1rem;\n  background-color: #2b132b;\n  padding: 1rem;\n  border-radius: 0.5rem;\n}\n\n.mod-link {\n  display: inline-block;\n  margin-bottom: 1.5rem;\n  font-weight: 500;\n  color: #0d6efd;\n  text-decoration: none;\n}\n\n.mod-link:hover {\n  text-decoration: underline;\n}\n\n.mod-chassis-label {\n  background-color: #ff009d;\n  color: #ffffff;\n  padding: 3px 8px;\n  margin: 2px;\n  border-radius: 4px;\n  display: inline-block;\n  font-size: 0.75rem;\n  font-weight: 500;\n}\n\n.mod-board-label {\n  background-color: #e0f7fa;\n  color: #007b83;\n  padding: 3px 8px;\n  margin: 2px;\n  border-radius: 4px;\n  display: inline-block;\n  font-size: 0.75rem;\n  font-weight: 500;\n}\n\n/* Mod Board Purchase Links */\n.mod-board-purchase-link {\n  background-color: #e0f7fa;\n  color: #007b83;\n  border: 1px solid #b2ebf2;\n  padding: 0.35rem 0.75rem;\n  margin-right: 0.5rem;\n  margin-bottom: 0.25rem;\n  border-radius: 6px;\n  display: inline-block;\n  font-size: 0.8rem;\n  font-weight: 500;\n  text-decoration: none;\n  transition: all 0.1s ease-in-out;\n  cursor: pointer;\n}\n\n.mod-board-purchase-link:hover {\n  background-color: #00525d;\n  color: #ffffff;\n  border-color: #80deea;\n  box-shadow: 0 2px 4px rgba(0, 123, 131, 0.2);\n  text-decoration: none;\n}\n\n.mod-board-purchase-link:active {\n  box-shadow: 0 1px 2px rgba(0, 123, 131, 0.2);\n}\n\n.info-card {\n  background-color: #2b132b;\n  border-radius: 0.5rem;\n  padding: 1rem;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);\n  font-size: 0.9rem;\n}\n\n.info-item {\n  margin-bottom: 0.5rem;\n}\n\n\n.crt-hero-image img {\n  width: 100%;\n  object-fit: contain;\n  border-radius: 8px;\n}\n\n.crt-gallery {\n  margin-top: 2rem;\n}\n\n.gallery-thumb:hover {\n  transform: scale(1.02);\n}\n\n.masonry-grid {\n  display: flex;\n  margin-left: -1rem; /* gutter */\n  width: auto;\n}\n.masonry-grid_column {\n  padding-left: 1rem; /* gutter */\n  background-clip: padding-box;\n}\n.gallery-thumb {\n  margin-bottom: 1rem;\n  width: 100%;\n  border-radius: 6px;\n}\n\n/* Add styles for the CRT summary section */\n.crt-summary {\n  background-color: rgba(0, 0, 0, 0.03);\n  border-radius: 8px;\n  line-height: 1.6;\n}\n\n.crt-summary h5 {\n  margin-bottom: 1rem;\n  color: #ccc;\n  font-weight: 600;\n}\n\n.crt-summary .markdown-body p {\n  margin-bottom: 1rem;\n}\n\n.crt-summary .markdown-body p:last-child {\n  margin-bottom: 0;\n}\n\n.crt-summary .markdown-body ul, \n.crt-summary .markdown-body ol {\n  padding-left: 1.5rem;\n  margin-bottom: 1rem;\n}\n\n.crt-summary .markdown-body a {\n  color: #0d6efd;\n  text-decoration: none;\n}\n\n.crt-summary .markdown-body a:hover {\n  text-decoration: underline;\n}\n\n.crt-summary .markdown-body code {\n  background-color: rgba(0, 0, 0, 0.1);\n  padding: 0.2rem 0.4rem;\n  border-radius: 3px;\n  font-family: monospace;\n}\n\n/* Community Contributions Section */\n.crt-community-content {\n  background-color: rgba(0, 0, 0, 0.03);\n  border-radius: 8px;\n}\n\n.crt-community-content h5 {\n  margin-bottom: 0.5rem;\n  color: #ccc;\n  font-weight: 600;\n}\n\n.community-content-description {\n  color: #aaa;\n  font-size: 0.9rem;\n}\n\n.community-thumb {\n  margin-bottom: 1rem;\n  width: 100%;\n  border-radius: 6px;\n  transition: transform 0.2s ease-in-out;\n}\n\n.community-thumb:hover {\n  transform: scale(1.02);\n}\n\n.community-placeholder {\n  background-color: #2b132b;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 150px;\n  color: #aaa;\n  text-align: center;\n  padding: 1.5rem;\n}\n\n.placeholder-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.placeholder-type {\n  background-color: rgba(255, 255, 255, 0.1);\n  padding: 0.15rem 0.5rem;\n  border-radius: 3px;\n  font-size: 0.7rem;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.placeholder-link {\n  margin-top: 0.5rem;\n  color: #0d6efd;\n  text-decoration: none;\n  font-size: 0.9rem;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  padding: 0.2rem 0.7rem;\n  border-radius: 3px;\n  transition: all 0.2s;\n}\n\n.placeholder-link:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n  color: white;\n}\n\n@media (max-width: 768px) {\n  .community-content-item {\n    margin-bottom: 1rem;\n  }\n  \n  .community-content-image {\n    margin-bottom: 0.5rem;\n  }\n  \n  .community-content-placeholder {\n    height: 100px;\n  }\n  \n  .community-content-title {\n    font-size: 0.9rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .crt-community-content {\n    padding: 1rem;\n  }\n  \n  .community-content-meta {\n    font-size: 0.7rem;\n  }\n  \n  .community-content-type {\n    font-size: 0.65rem;\n    padding: 0.1rem 0.3rem;\n  }\n}\n\n/* Adjust masonry grid specifically for community content */\n.crt-community-content .masonry-grid_column > div {\n  margin-bottom: 20px;\n}\n\n/* Community contributions now use the same masonry grid as gallery images */\n\n.community-contributors {\n  font-size: 0.85rem;\n  color: #a0a0a0;\n  margin-top: -5px;\n}\n\n.contributor {\n  font-weight: 500;\n}\n\n.community-date {\n  color: #888;\n  font-style: italic;\n}\n\n.community-product-section {\n  margin-bottom: 2rem;\n  padding-bottom: 1.5rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.community-product-section:last-child {\n  border-bottom: none;\n  padding-bottom: 0;\n}\n\n.community-product-header {\n  margin-bottom: 1rem;\n}\n\n.community-product-title {\n  margin-bottom: 0.3rem;\n  font-size: 1.1rem;\n}\n\n.community-product-title a {\n  color: #0d6efd;\n  text-decoration: none;\n}\n\n.community-product-title a:hover {\n  text-decoration: underline;\n}\n\n.community-product-meta {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  font-size: 0.85rem;\n  color: #aaa;\n  margin-bottom: 0.5rem;\n}\n\n.community-store-name {\n  font-weight: 500;\n}\n\n.community-product-type {\n  background-color: #2b132b;\n  padding: 0.15rem 0.4rem;\n  border-radius: 3px;\n  font-size: 0.7rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.community-product-price {\n  font-weight: bold;\n  color: #d32f2f;\n  margin-left: auto;\n}\n\n.community-product-date {\n  color: #888;\n  font-style: italic;\n  font-size: 0.8rem;\n}\n\n.community-product-intro {\n  font-size: 0.9rem;\n  line-height: 1.5;\n  margin-bottom: 1rem;\n  color: #d9d9d9;\n  max-width: 100%;\n  overflow-wrap: break-word;\n}\n\n/* Modal Navigation Buttons */\n.modal-nav-btn {\n  background: none !important;\n  border: none !important;\n  color: white;\n  text-shadow: 0 0 3px rgba(0,0,0,0.8);\n  transition: all 0.2s ease;\n  cursor: pointer;\n  z-index: 1050;\n}\n\n.modal-nav-btn:hover {\n  transform: scale(1.1);\n  color: #ea3377 !important;\n}\n\n.modal-nav-btn:focus {\n  outline: none;\n  box-shadow: none;\n}\n\n.modal-nav-btn:active {\n  transform: scale(1.05);\n}\n\n/* Modal Image Styling */\n.modal-image-container {\n  padding: 60px;\n  height: 95vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.modal-image {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n  border-radius: 6px;\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
